@if (imageArr.length > 0) {
  <ngb-carousel role="listbox">
    @for (listingMedia of imageArr; track listingMedia.id) {
      <ng-template ngbSlide class="carousel slide" data-ride="carousel">
        <a [routerLink]="'fulldetails/' + addressHyphenStr + '/' + cityHyphenStr + '/' + MLSNum">
          <img class="img-fluid  w-100"
               src="{{normalizeImageUrl(listingMedia.url)}}"
               alt="{{MLSNum}}"/></a>
      </ng-template>
    }
  </ngb-carousel>
}
